'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseContentCard = function BaseContentCard(_ref) {
  var meta = _ref.meta,
      tags = _ref.tags,
      onClickTag = _ref.onClickTag,
      showPaywall = _ref.showPaywall,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-base-content-card' },
    _react2.default.createElement(
      'div',
      { className: 'quiver-base-content-card__meta' },
      meta
    ),
    children,
    !showPaywall && _react2.default.createElement(
      'ul',
      { className: 'quiver-base-content-card__tags' },
      tags.map(function (tag) {
        return _react2.default.createElement(
          'li',
          { key: tag.name },
          tag.url ? _react2.default.createElement(
            'a',
            { href: tag.url, onClick: function onClick() {
                return onClickTag && onClickTag(tag);
              } },
            tag.name
          ) : tag.name
        );
      })
    )
  );
};

BaseContentCard.propTypes = {
  meta: _propTypes2.default.string.isRequired,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string
  })).isRequired,
  onClickTag: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired,
  showPaywall: _propTypes2.default.bool
};

BaseContentCard.defaultProps = {
  onClickTag: null,
  showPaywall: false
};

exports.default = BaseContentCard;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseContentCard/BaseContentCard.js
// module id = 520
// module chunks = 11